// EDUX.ME autentica no Keycloak da Innyx; o SIGEAM usa o realm "sigeam" da PRODAM
export const isEduxme = (): boolean =>
  (process.env.VUE_APP_KEYCLOAK_SERVER_URL || "").includes("auth.innyx.com") &&
  process.env.VUE_APP_KEYCLOAK_REALM !== "sigeam";

const ACOES_DE_ALTERACAO = /^(salvar|alterar|atualizar|confirmar|gravar)\b/i;

// Marca botões de alteração para receberem o estilo do botão Módulos
const marcarBotoesDeAlteracao = () => {
  document.querySelectorAll(".btn-primary").forEach((botao) => {
    const texto = (botao.textContent || "").trim();
    botao.classList.toggle(
      "btn-eduxme-alteracao",
      ACOES_DE_ALTERACAO.test(texto)
    );
  });
};

const trocarFavicon = () => {
  document.querySelectorAll("link[rel~='icon']").forEach((l) => l.remove());
  const favicon = document.createElement("link");
  favicon.rel = "icon";
  favicon.type = "image/png";
  favicon.href = "/media/logos/favicon-eduxme.png";
  document.head.appendChild(favicon);
};

export const aplicarTemaEduxme = (): void => {
  document.documentElement.classList.add("tema-eduxme");
  trocarFavicon();

  let agendado = false;
  new MutationObserver(() => {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(() => {
      agendado = false;
      marcarBotoesDeAlteracao();
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
};
